/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeWinnerBody
 */
export interface DistributeWinnerBody {
    /**
     * User ID of the single winner to distribute.
     * @type {string}
     * @memberof DistributeWinnerBody
     */
    winnerUserId: string;
}

/**
 * Check if a given object implements the DistributeWinnerBody interface.
 */
export function instanceOfDistributeWinnerBody(value: object): value is DistributeWinnerBody {
    if (!('winnerUserId' in value) || value['winnerUserId'] === undefined) return false;
    return true;
}

export function DistributeWinnerBodyFromJSON(json: any): DistributeWinnerBody {
    return DistributeWinnerBodyFromJSONTyped(json, false);
}

export function DistributeWinnerBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeWinnerBody {
    if (json == null) {
        return json;
    }
    return {
        
        'winnerUserId': json['winnerUserId'],
    };
}

export function DistributeWinnerBodyToJSON(json: any): DistributeWinnerBody {
    return DistributeWinnerBodyToJSONTyped(json, false);
}

export function DistributeWinnerBodyToJSONTyped(value?: DistributeWinnerBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winnerUserId': value['winnerUserId'],
    };
}

